<template>
    <div class="mtg-agents-block__body">
        <div v-if="data.data && data.data.items && data.data.items.length" class="mtg-agents-block__head g-text__p _gray g_semibold">Документы</div>
        <div v-if="data.data && data.data.items && data.data.items.length" class="mtg-agents-block__docs">
            <a
                v-for="(doc, idx) in data.data.items"
                :key="`doc-${idx}`"
                class="mtg-agents-block__doc u-link__download"
                :href="doc.props.file.src"
                target="_blank"
            >
                <span class="u-link__download-text g_medium">{{ doc.name }}</span>
            </a>
        </div>
        <div class="mtg-agents-block__subtitle">
            <h4 class="g-h-20 g-h-m-18 g_semibold">Документация по выпуску облигаций:</h4>
        </div>
        <div class="mtg-agents-block__tabs">
            <div
                v-for="(tab, idx) in sections"
                :key="`section-${idx}`"
                @click.prevent="activeIdx = idx"
                :class="{ _active: idx === activeIdx }"
                class="mtg-agents-block__tab"
            >{{ tab }}</div>
        </div>
        <div
            v-for="(section, idx) in tabsContent"
            :key="`section-${idx}`"
            class="mtg-agents-block__section"
        >
            <div v-if="idx === activeIdx">
                <div class="mtg-agents-block__head g-text__p _gray g_semibold">Документы</div>
                <div class="mtg-agents-block__docs">
                    <a
                        v-for="(doc, idx) in section"
                        :key="`doc-${idx}`"
                        class="mtg-agents-block__doc u-link__download"
                        :href="doc.props && doc.props.file ? doc.props.file.src : '#!'"
                        target="_blank"
                    >
                        <span class="u-link__download-text g_medium">{{ doc.name }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MortAgentsDocsWithSections',
    props: {
        data: {
            type: Object,
            default () {
                return [];
            }
        }
    },
    data() {
        return {
            sections: [],
            tabsContent: [],
            activeIdx: 0
        };
    },
    created() {
        const curData = this.data.data.sections;

        for(let key in curData) {
            this.sections.push(curData[key].name);
            this.tabsContent.push(curData[key].items);
        }
    }
};
</script>
